import { ActionSheet, Dialog, List, Popup, Selector, Space } from "antd-mobile"
import { InputView, ListView, SelectView, TradeFuturesBodyView, TradeButtonView, TradeHeaderView, DividerTradeView } from "../factory/ViewUtil"
import { CellStateView } from "../factory/CellViews"
import React, { useCallback, useEffect, useImperativeHandle, useState } from "react";
import { AlertContent, BigDecimalZero, DecimalComparedToZero, DecimalConvert, ToastClear, ToastContent, ToastLoading, TradeLightValueColor } from "../factory/FactoryUtil";
import { CloseFutureOrder, isLogin, RequestMarketDepth, RequestTradeFuturesProfiting, SendTradeFutures } from "../../NetworkFactory";
import { AssetsListener, AssetsListenerRemove, RefreshAssets } from "../assets/AssetsManager";
import { NavbarHistoryIcon } from "../icons";
import { FutureCellView } from "./TradeCellView";

const optionsData = [
    {label: '25%', value: '25'},
    {label: '50%', value: '50'},
    {label: '75%', value: '75'},
    {label: '100%', value: '100'}
];

const LineItemView = React.memo(({left = 'left', right = ''}) => {
    return (
        <div style={{display : 'flex', alignItems: 'center', margin : '20px 0', fontSize : '15px'}}>
            <div>{left}</div>
            <div style={{flex : '1', margin : '0 10px'}}><div style={{height : '1px', background : 'rgba(0,0,0,0.05)'}}></div></div>
            <div style={{fontWeight: 'bold'}}>{right}</div>
        </div>
    )
})

export const FuturesTradeViewController = React.forwardRef((props, ref) => {

    const [updateCounter, setUpdateCounter] = useState(0)

    const updateSymbolData = (data) => {
        setSymbolData(data)
        setSymbol(data.symbol)
        setMarketPrice(data.close + '')
        setUpdateCounter(updateCounter+1)
    }

    const currentSymbolData = () => {
        return symbolData
    }

    //将子组件的方法 暴露给父组件
    useImperativeHandle(ref, () => ({
        currentSymbolData, updateSymbolData
    }))

    const [symbol, setSymbol] = useState(localStorage.getItem('f_symbol') || 'BTC/USDT');
    const [symbolData, setSymbolData] = useState({
        symbol : symbol,
        open : '0.00',
        close : '0.00', 
        high : '0.00', 
        low : '0.00'
    });
    const [tradeType, setTradeType] = useState(true)
    const [priceText, setPriceText] = useState('Market Price')
    const [marketPrice, setMarketPrice] = useState('0')
    const [priceType, setPriceType] = useState(true)
    const [multiplesText, setMultiplesText] = useState('1')
    const [depthData, setDepthData] = useState({})

    const [price, setPrice] = useState('')
    const [amount, setAmount] = useState('')
    const [commission, setCommission] = useState('0.00')
    const [margin, setMargin] = useState('0.00')
    const [password, setPassword] = useState('')

    const [perValue, setPerValue] = useState(0)
    const [tradeButtonText, setTradeButtonText] = useState('...')
    const [assetsData, setAssetsData] = useState([])
    const [buyAssets, setBuyAssets] = useState({})

    const [postConfirm, setPostConfirm] = useState(false)

    const [orderData, setOrderData] = useState([])
    const [stateCode, setStateCode] = useState(4);

   //=========================================================
    // # 请求深度数据
    const requestDepthData = () => {
        RequestMarketDepth(symbol).then(response => {
            const count = 8
            const {asks = [], bids = []} = response.data || {}
            let asksData = []
            let asksMaxPrice = BigDecimalZero('0')
            for(let i=0;i<asks.length;i++) {
                const {price, amount} = asks[i] || {}
                if(BigDecimalZero(amount).comparedTo(asksMaxPrice) > 0) {
                    asksMaxPrice = BigDecimalZero(amount)
                }

                asksData.push({
                    price : DecimalConvert(price),
                    amount : DecimalConvert(amount)
                })
                if(asksData.length >= count) {
                    break
                }
            }
            let bidsData = []
            let bidsMaxPrice = BigDecimalZero('0')
            for(let i=0;i<bids.length;i++) {
                const {price, amount} = bids[i] || {}
                if(BigDecimalZero(amount).comparedTo(asksMaxPrice) > 0) {
                    bidsMaxPrice = BigDecimalZero(amount)
                }

                bidsData.push({
                    price : DecimalConvert(price),
                    amount : DecimalConvert(amount)
                })
                if(bidsData.length >= count) {
                    break
                }
            }
            updateDepthData(asksData, asksMaxPrice, 
                            bidsData, bidsMaxPrice)
            
        })
    }

    const updateDepthData = (asksData, asksMaxPrice, bidsData, bidsMaxPrice) => {
        if(marketPrice === '0') {
            return
        }
        const sortAsksData = asksData.sort((a, _) => {
            return BigDecimalZero(marketPrice).comparedTo(BigDecimalZero(a.price))
        });

        const sortBidsData = bidsData.sort((a, b) => {
            return BigDecimalZero(marketPrice).comparedTo(BigDecimalZero(a.price))
        });

        setDepthData({
            asks : {
                max : asksMaxPrice,
                data : sortAsksData
            },
            bids : {
                max : bidsMaxPrice,
                data : sortBidsData
            },
            marketPrice : marketPrice
        })
    }

    //=========================================================
    // # 符号变化保存
    useEffect(() => {
        if(symbol) {
            localStorage.setItem('f_symbol', symbol)


            //=========================================================
            // # 符号变化恢复默认参数
            setAmount('');  // # 清空手数
            if(!priceType) {
                 setPrice(marketPrice + '') // 首次市场价
            }
            setPerValue(0)  // # 百分比
            //=========================================================

        }
    }, [symbol]) // eslint-disable-line react-hooks/exhaustive-deps
    //=========================================================

    //=========================================================
    // # 计数器更新深度数据
    useEffect(() => {
        if(symbol) {
            if(marketPrice !== '0') {
                requestDepthData()
            }
        }
    }, [symbol, marketPrice, updateCounter]) // eslint-disable-line react-hooks/exhaustive-deps

    //=========================================================
    // # 交易类型变化
    useEffect(() => {
        if(isLogin()) {
            setTradeButtonText(tradeType ? 'Buy (long)' : 'Sell (short)')
        } else {
            setTradeButtonText('Login to trade')
        }
        
    }, [symbol, tradeType]) // eslint-disable-line react-hooks/exhaustive-deps
    //=========================================================

    //=========================================================
    // # 资产监听和刷新
    useEffect(() => {
        if(isLogin()) {
            requestProfiting()
            AssetsListener('2', 'FuturesTradeViewController', ({data = []}) => {
                setAssetsData(data)
            })
            return () => {
                AssetsListenerRemove('2', 'FuturesTradeViewController')
            }
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps
    useEffect(() => {
        if(symbol && isLogin() && assetsData.length > 0) {
            const currencys = symbol.split('/') // BTC/USDT
            if(currencys.length !== 2) {
                return
            }
            let balance = currencys[1] // USDT
            for(let i=0;i<assetsData.length;i++) {
                const item = assetsData[i];
                if(balance === item.symbol) {
                    setBuyAssets({...item})
                }
            }

        }
    }, [symbol, assetsData]) // eslint-disable-line react-hooks/exhaustive-deps

    //=========================================================
    // 数据变化监听
    useEffect(() => {
        if(perValue.length === 0) {
            setAmount('')
            return
        }
        const perv = perValue[0]
        if(DecimalComparedToZero(perv) <= 0) {
            return
        }
        let tradePrice = priceType ? marketPrice : (price.length > 0 ? price : '0')
        if(DecimalComparedToZero(tradePrice) <= 0) {
            setAmount('')
            return
        }
        const {available = '0.00'} = buyAssets
        if(DecimalComparedToZero(available) > 0) {
            const spend = BigDecimalZero(available).mul(BigDecimalZero(perv).div(BigDecimalZero(100)))
            const amount = spend.div(BigDecimalZero(tradePrice)).toString()
            setAmount(DecimalConvert(amount))
        }
        
    }, [price, perValue, buyAssets]) // eslint-disable-line react-hooks/exhaustive-deps
    // marketPrice

    const selectPriceType = () => {
        const actions = [
            {key : '1', text : 'Market Price'},
            {key : '2', text : 'Fixed Price'}
        ]
        const handler = ActionSheet.show(
            {
                extra : <div style={{textAlign : 'center'}}><div style={{color : '#000', fontSize : '18px', marginBottom : '6px'}}>Please select price type</div></div>,
                cancelText : 'Cancel',
                actions : actions,
                onAction : item => {
                    handler.close()
                    setPriceText(item.text)
                    setPrice(item.key === '1' ? '' : marketPrice + '');
                    setPriceType(item.key === '1')
                    //console.log(`====${item.key}===${marketPrice}`);
                }
            }
        )
    }

    const selectMultiples = () => {
        const data = ['1', '5', '10', '20', '50', '100']
        let actions = []
        data.forEach(item => {
            actions.push({
                key : item,
                text : item
            })
        })
        const handler = ActionSheet.show(
            {
                extra : <div style={{textAlign : 'center'}}><div style={{color : '#000', fontSize : '18px', marginBottom : '6px'}}>Please select multiples</div></div>,
                cancelText : 'Cancel',
                actions : actions,
                onAction : item => {
                    setMultiplesText(item.text)
                    handler.close()
                }
            }
        )
    }

    //=========================================================
    // # 正在交易的数据
    const requestProfiting = useCallback(() => {
        setStateCode(3)
        RequestTradeFuturesProfiting().then(response => {
            const {data = []} = response.data || {}
            setOrderData(data)
            setStateCode(data.length > 0 ? -1 : 1)
        }).catch(() => {
            setStateCode(1)
        })
    }, [])

    const goRecharge = (limit) => {
        Dialog.confirm({
            content : <div style={{textAlign : 'center', fontWeight : 'bold', fontSize : '17px'}}>
                It's not yet the delivery time, if your Assets amount greater than or equal to {limit} USDT Can be closed in advance of delivery
            </div>,
            cancelText : 'Cancel',
            confirmText : 'Recharge',
            onConfirm: () => {
                props.navpush('/recharge')
            }
        })
    }

    // # 用户平仓
    const onClose = ({id = ''}) => {
        if(id.length === 0) {
            ToastContent('Error')
            return
        }
        ToastLoading('Closing...')
        CloseFutureOrder(id).then(response => {
            ToastClear()
            const {status = -1, offset} = response.data || {}
            if(status === 200) {
                if(offset) {
                    goRecharge(offset)
                } else {
                    requestProfiting()
                    RefreshAssets('2')
                }
            } else if(status === -4) {
                // # 用户无法平仓
                AlertContent('Unable to close order')
            } else if(status === -5) {
                // # 条件不足
                AlertContent('Insufficient closing conditions')
            } else {
                ToastContent('Error')
            }
        }).catch(() => {
            ToastContent('Error')
        })
    }

    //=========================================================
    // # 提交交易
    const postTrade = () => {
        if(!isLogin()) {
            props.navpush('/login')
            return
        }
        
        if(!symbol) {
            ToastContent('Currency cannot be empty')
            return
        }

        // # 合约最小保证金、手续费率
        const {lever_min_deposit_money = '0', poundage_rate = '0'} = symbolData

        // # 余额
        const {available = '0'} = buyAssets
        if(DecimalComparedToZero(available) <= 0) {
            ToastContent('Insufficient balance')
            return
        }

        if(DecimalComparedToZero(marketPrice) <= 0) {
            ToastContent('No transaction price data')
            return
        }

        if(DecimalComparedToZero(amount) <= 0) {
            ToastContent('Invalid number of hand')
            return
        }

        const tradePrice = price.length > 0 ? price : marketPrice
        if(DecimalComparedToZero(tradePrice) <= 0) {
            ToastContent('No unit price or invalid')
            return
        }

        if(DecimalComparedToZero(multiplesText) <= 0) {
            ToastContent('Invalid multiple')
            return
        }

        // # 保证金
        const needMargin = BigDecimalZero(tradePrice).mul(BigDecimalZero(amount))
        // # 最小保证金
        if(DecimalComparedToZero(lever_min_deposit_money) > 0) {
            if (needMargin.comparedTo(BigDecimalZero(lever_min_deposit_money)) < 0) {
                const name = symbol.split('/')[0] // BTC/USDT
                ToastContent(`Minimum margin ${lever_min_deposit_money} ${name}`)
                return
            }
        }
        setMargin(DecimalConvert(needMargin))
        const poundage = needMargin.mul(BigDecimalZero(poundage_rate))
        setCommission(DecimalConvert(poundage))
        setPostConfirm(true)
    }

    const postTradeConfirm = () => {
        if(password.length !== 6) {
            ToastContent('Payment password is invalid')
            return
        }
        setPostConfirm(false)
        ToastLoading(tradeType ? 'Buy Posting' : 'Sell Posting')
        const data = {
            price : DecimalConvert(price.length > 0 ? price : marketPrice, 0),
            multiple : multiplesText,
            hands : amount,
            symbol : symbol,
            password : password
        }
        SendTradeFutures(tradeType, data).then(response => {
            ToastClear()
            const {status = -1} = response.data || {}
            if(status === -1) {
                AlertContent('Abnormal transaction')
            }
            else if(status === -4) {
                AlertContent('Payment password not set')
            }
            else if(status === -5) {
                AlertContent('Payment password error')
            }
            else if(status === -102) {
                AlertContent('Insufficient Balance')
            }
            else if(status === -405) {
                AlertContent('You have been banned from trading')
            }
            else if(status === 200) {
                ToastContent(`${tradeType ? 'Buy' : 'Sell'} Success`)
                requestProfiting()
                RefreshAssets('')
            }

        }).catch(() => {
            AlertContent('Abnormal transaction')
        })
    }

    // # 关注符号
    const [followed, setFollowed] = useState(false);
    useEffect(() => {
        if(isLogin()) {
            setFollowed(symbolData.isFollowed === true)
        }
    }, [symbolData]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div style={{padding : '0 18px'}}>
            <ListView>
                <List.Item style={{margin : '10px 0'}}>
                    <TradeHeaderView
                        followed={followed}
                        data={symbolData}
                        onClick={()=>{props.visibleMarketPopup('2')}}
                        goTrend={()=>{props.navpush('/trend', false, symbolData)}}
                    />
                </List.Item>

                <List.Item>
                    <TradeFuturesBodyView depthData={depthData}>
                    <Space direction='vertical' style={{'--gap-vertical' : '16px', width : '100%'}}>
                        <DividerTradeView 
                            onChange={(val)=>{setTradeType(val)}}
                            color = {tradeType ? '#08BF89' : '#D92727'}
                            left={tradeType} 
                            leftText="Buy" 
                            rightText="Sell"
                        />
                        
                        <div style={{display : 'flex'}}>
                            <SelectView onClick={selectPriceType} style={{flex: '1', borderColor : '#ccc'}}>{priceText}</SelectView>
                            <div style={{width : '6px'}}></div>
                            <SelectView onClick={selectMultiples} style={{minWidth: '40px', borderColor : '#ccc'}}>{multiplesText}</SelectView>
                        </div>

                        <InputView 
                            title='Price' color='#ccc' 
                            placeholder={priceType ? 'Curent base price' : ''} 
                            readOnly={priceType}
                            value={price} 
                            onChange={val => {
                                if(DecimalComparedToZero(val) >= 0) {
                                    if(BigDecimalZero(val).decimalPlaces() <= 8) {
                                        setPrice(val)
                                    }
                                }
                            }}
                        />
                        <InputView title='Number of hand' color='#ccc' value={amount} onChange={val => {
                            setAmount(val + '');
                            setPerValue(0)
                        }}/>
                        <Selector 
                            columns={optionsData.length} 
                            options={optionsData} 
                            showCheckMark={false} 
                            style={{
                                '--padding' : '3.5px 0', 
                                '--border-radius' : '6px',
                                '--border': 'solid #F1F1F1 1px',
                                '--text-color' : '#A0A0A0',
                                '--checked-border': 'solid '+(tradeType ? '#08BF89' : '#D92727')+' 1px',
                                '--checked-color' : tradeType ? '#08BF89' : '#D92727',
                                '--color' : 'transparent',
                                '--checked-text-color' : '#FFF',
                                fontSize : '12px'}
                            } 
                            value={perValue}
                            onChange={(val)=> {
                                setPerValue(val)
                            }}
                        />
                        <div style={{fontSize : '12px'}}>Balance {buyAssets.available} {buyAssets.symbol}</div>
                        <TradeButtonView onClick={postTrade} style={{background : TradeLightValueColor(tradeType, true)}}>{tradeButtonText}</TradeButtonView>
                    </Space>
                    </TradeFuturesBodyView>
                </List.Item>
                
                <List.Item style={{fontSize : '18px', fontWeight : 'bold', margin : '15px 0'}}>
                    <div style={{display : 'flex', alignItems : 'center'}}>
                        <div style={{flex : '1'}}>Open orders</div>
                        <div onClick={()=>{props.loginpush('./futures/order')}}><NavbarHistoryIcon/></div>
                    </div>
                </List.Item>

                <List.Item style={{margin : '0 0 20px 0'}}>
                    <CellStateView stateType={stateCode}/>
                    {
                        orderData.map((item, index) => (
                            <FutureCellView onDo={()=>{onClose(item)}} buttonText='Close' data={item} key={index}/>
                        ))
                    }
                </List.Item>
            </ListView>
            
            <Popup visible={postConfirm} onMaskClick={()=>{setPostConfirm(false)}} bodyStyle={{
                borderTopLeftRadius: '16px',
                borderTopRightRadius: '16px',
                fontSize : '17px',
                color : '#000',
                padding : '20px',
                boxSizing : 'border-box'
            }}>
                <div style={{textAlign : 'center', fontSize : '18px', fontWeight : 'bold'}}>{symbol}</div>
                <LineItemView left='Type' right={tradeType ? 'Long' : 'Short'}/>
                <LineItemView left='Number of hand' right={amount}/>
                <LineItemView left='Multiple' right={multiplesText}/>
                <LineItemView left='Commission' right={commission}/>
                <LineItemView left='Margin' right={margin}/>
                <div style={{marginTop : '40px'}}>
                    <InputView type='password' title='Payment password' color='#ccc' value={password} onChange={(val)=>{setPassword(val)}}/>
                </div>
                <div className='dividerView' style={{width : '100%', margin : '20px 0 '}}>
                    <div onClick={postTradeConfirm} className='dividerItemView dividerLeftView' style={{height : '44px'}}><span>Confirm</span></div>
                    <div onClick={()=>{setPostConfirm(false)}} className='dividerItemView dividerRightView' style={{height : '44px'}}>Cancel</div>
                </div>

            </Popup>
        </div>
    )
})